module.exports = Promise.all([parcelRequire.load("aW7bM"), parcelRequire.load("ihb8B")]).then(() => parcelRequire('gHsis'));